/**

* © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile

* Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United

* States and/or other countries.

*/

import * as actionTypes from './WaiverActiontypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import axios from 'axios';
import { commonAPIHandler } from '../../../../SharedModules/ServerErrorHandler/index';

const headers = {
  'Access-Control-Allow-Origin': '*'
};

export const getDropdownDataAction = (value) => {
    return dispatch => {
      return axios.post(`${serviceEndPoint.DROPDOWNS}`, value)
        .then(response => {
            let sendingResponse = commonAPIHandler(response);
          dispatch(setDropdownData(sendingResponse));
        })
        .catch(error => {
            let sendingResponse = commonAPIHandler(error);
          dispatch(setDropdownData(sendingResponse));
        });
    };
  };

  export const searchWaiverction = (value) => {
    return dispatch => {
      return axios.post(`${serviceEndPoint.SEARCH_WAIVER}`, value)
        .then(response => {
            let sendingResponse = commonAPIHandler(response, true);
          dispatch(setSearchData(sendingResponse));
        })
        .catch(error => {
            let sendingResponse = commonAPIHandler(error);
          dispatch(setSearchData(sendingResponse));
        });
    };
  };

  export const createWaiverAction = (value) => {
    return dispatch => {
      return axios.post(`${serviceEndPoint.ADD_WAIVER}`, value)
        .then(response => {
            let sendingResponse = commonAPIHandler(response);
          dispatch(setAddresponse(sendingResponse));
        })
        .catch(error => {
            let sendingResponse = commonAPIHandler(error);
          dispatch(setAddresponse({systemFailure: true}));
        });
    };
  };

  
  export const updateWaiverAction = (value) => {
    return dispatch => {
      return axios.post(`${serviceEndPoint.UPDATE_WAIVER}`, value)
        .then(response => {
            let sendingResponse = commonAPIHandler(response);
          dispatch(setUpdateresponse(sendingResponse));
        })
        .catch(error => {
            let sendingResponse = commonAPIHandler(error);
          dispatch(setUpdateresponse({systemFailure: true}));
        });
    };
  };

  export const setUpdateresponse = (updateResponse) => {
    return {
        type: actionTypes.UPDATE_WAIVER,
        updatePayload: updateResponse
    }
}

  export const setAddresponse = (addResponse) => {
      return {
          type: actionTypes.CREATE_WAIVER,
          createPayload: addResponse
      }
  }

  export const setSearchData = (searchData) => {
      return {
          type: actionTypes.SEARCH_WAIVER,
          searchPayload: searchData
      }
  }
  
  export const setDropdownData = (dropdownData) => {
    return {
      type: actionTypes.DROPDOWNDATA,
      dropdownData: dropdownData
    };
  };
  export const ResetWVR = (keyName) => {
    return {
        type: actionTypes.RESET_WAIVER,
        keyName: keyName
    }
  }